import type { SupportedRepubName } from '@cx-web/domain-types';
import { PLUS_CONFIGS } from '@cx-web/repub-config';

import { type Repub } from '@cx-modules/types';

import { BETTING_SPLITS_CONFIGS } from './betting-splits-config';
import { CATEGORY_ORDERING_CONFIGS } from './category-ordering-config';
import { FAQ_CONFIGS } from './faq-config';
import { LANDING_PAGE_CONFIGS } from './landing-page-config';
import { LOGO_CONFIGS, LOGO_URL_CONFIGS } from './logo-config';
import { MATCHUP_CENTRE_CONFIGS } from './matchup-centre-config';
import { PLUS_HOME_PAGE_PATHS, PLUS_TOOLS_RESTRICTED } from './misc-config';
import { NAVIGATION_CONFIGS } from './navigation-config';
import { PAYWALL_CONFIGS } from './paywall-config';
import { SUBSCRIPTION_CONFIGS } from './subscription-config';
import { TIPSTERS_CONFIG } from './tipsters-config';
import { TRACKING_CONFIGS } from './tracking-config';
import { TRENDS_CONFIGS } from './trends-config';
import type { RepubConfig } from './types';
import { UI_BEHAVIOR_CONFIGS } from './ui-behavior-config';
import { VALUE_BETS_CONFIGS } from './value-bets-config';

/**
 * Main configuration object mapping republic names to their configurations
 * Assembled from individual section configs
 */
export const PLUS_REPUB_CONFIG: Partial<Record<Repub, RepubConfig>> & Record<SupportedRepubName, RepubConfig> = {
  WS: {
    ...PLUS_CONFIGS.WS,
    bettingSplits: BETTING_SPLITS_CONFIGS.WS,
    matchupCentre: MATCHUP_CENTRE_CONFIGS.WS,
    categoryOrdering: CATEGORY_ORDERING_CONFIGS.WS,
    faq: FAQ_CONFIGS.WS,
    landingPage: LANDING_PAGE_CONFIGS.WS,
    logo: LOGO_CONFIGS.WS,
    logoUrl: LOGO_URL_CONFIGS.WS,
    navigation: NAVIGATION_CONFIGS.WS,
    paywall: PAYWALL_CONFIGS.WS,
    plusHomePagePath: PLUS_HOME_PAGE_PATHS.WS,
    plusToolsRestricted: PLUS_TOOLS_RESTRICTED.WS,
    subscription: SUBSCRIPTION_CONFIGS.WS,
    tracking: TRACKING_CONFIGS.WS,
    trends: TRENDS_CONFIGS.WS,
    valueBets: VALUE_BETS_CONFIGS.WS,
    oddsFormatCookieKey: 'ws-of',
    oddsFormatMap: {
      '0': 'decimal',
      '1': 'fractional',
      '2': 'american',
    },
    uiBehavior: UI_BEHAVIOR_CONFIGS.WS,
  },
  US: {
    ...PLUS_CONFIGS.US,
    bettingSplits: BETTING_SPLITS_CONFIGS.US,
    categoryOrdering: CATEGORY_ORDERING_CONFIGS.US,
    faq: FAQ_CONFIGS.US,
    matchupCentre: MATCHUP_CENTRE_CONFIGS.US,
    landingPage: LANDING_PAGE_CONFIGS.US,
    logo: LOGO_CONFIGS.US,
    navigation: NAVIGATION_CONFIGS.US,
    paywall: PAYWALL_CONFIGS.US,
    plusHomePagePath: PLUS_HOME_PAGE_PATHS.US,
    subscription: SUBSCRIPTION_CONFIGS.US,
    tracking: TRACKING_CONFIGS.US,
    trends: TRENDS_CONFIGS.US,
    tipsters: TIPSTERS_CONFIG.US,
    valueBets: VALUE_BETS_CONFIGS.US,
    oddsFormatCookieKey: 'odds_format',
    uiBehavior: UI_BEHAVIOR_CONFIGS.US,
  },
  OC: {
    ...PLUS_CONFIGS.OC,
    bettingSplits: BETTING_SPLITS_CONFIGS.OC,
    categoryOrdering: CATEGORY_ORDERING_CONFIGS.OC,
    faq: FAQ_CONFIGS.OC,
    matchupCentre: MATCHUP_CENTRE_CONFIGS.OC,
    landingPage: LANDING_PAGE_CONFIGS.OC,
    logo: LOGO_CONFIGS.OC,
    navigation: NAVIGATION_CONFIGS.OC,
    paywall: PAYWALL_CONFIGS.OC,
    plusHomePagePath: PLUS_HOME_PAGE_PATHS.OC,
    subscription: SUBSCRIPTION_CONFIGS.OC,
    tracking: TRACKING_CONFIGS.OC,
    trends: TRENDS_CONFIGS.OC,
    tipsters: TIPSTERS_CONFIG.OC,
    valueBets: VALUE_BETS_CONFIGS.OC,
    oddsFormatCookieKey: 'odds_type',
    uiBehavior: UI_BEHAVIOR_CONFIGS.OC,
  },
  GZ: {
    ...PLUS_CONFIGS.GZ,
    bettingSplits: BETTING_SPLITS_CONFIGS.GZ,
    categoryOrdering: CATEGORY_ORDERING_CONFIGS.GZ,
    faq: FAQ_CONFIGS.GZ,
    landingPage: LANDING_PAGE_CONFIGS.GZ,
    logo: LOGO_CONFIGS.GZ,
    matchupCentre: MATCHUP_CENTRE_CONFIGS.GZ,
    navigation: NAVIGATION_CONFIGS.GZ,
    paywall: PAYWALL_CONFIGS.GZ,
    plusHomePagePath: PLUS_HOME_PAGE_PATHS.GZ,
    subscription: SUBSCRIPTION_CONFIGS.GZ,
    tracking: TRACKING_CONFIGS.GZ,
    trends: TRENDS_CONFIGS.GZ,
    valueBets: VALUE_BETS_CONFIGS.GZ,
    tipsters: TIPSTERS_CONFIG.GZ,
    oddsFormatCookieKey: 'odds_type',
    uiBehavior: UI_BEHAVIOR_CONFIGS.GZ,
  },
};
